import apiService from "../../../Services/APIService";
import { checkAPIResponse } from "../../../Utils/APIResponseUtils";
import { getAuthData } from "../../../Utils/AuthUtils";
import { getLastSyncDT } from "../../../Utils/APIConfig";
import { getTimeZone } from "../../../Utils/Utilities";

// API for verifying mobile number
export const sendOTPAPI = async () => {
  try {
    let verifyUserObj = { sysChangeType: "ADMNCHNG" };
    const result = await apiService.accessGetData(11, 'sendOTP', verifyUserObj);
    return result;
  } catch (error) {
    console.error('Error verifying mobile:', error);
    throw error;
  }
};

export const changeAdminAPI = async (changeType, data) => {
  try {
    let payload = {
      changeType: changeType,
      sysChangeType: "ADMNCHNG",
      otp: data.otp,
      cc: data.cc || "91",
      mobile: data.mobile || "",
      value: data.pocUserID || 0,
      values: '',
      key: 0
    }
    const result = await apiService.sendChange(11, 'set', payload);
    return result;
  } catch (error) {
    console.error('Error verifying mobile:', error);
    throw error;
  }
};

export const addBusinessAPI = async (businessData, operation = 'ADD') => {
  try {
    const isDelete = operation === 'DELETE';
    const d = businessData;

    const authData = getAuthData();
    if (!authData) {
      throw new Error('Authentication data not found');
    }
    const isWeb = apiService.apiCheckWeb();

    const lastSyncDT = getLastSyncDT();

    const preparedBusinessData = [{
      userID: authData?.UserID || authData?.userID || 0,
      forAgencyID: authData?.AgencyID || authData?.forAgencyID || 0,
      token: !isWeb ? (authData?.AppToken || authData?.WebToken || '') : (authData?.WebToken || ''),
      lastSyncDT: lastSyncDT || null,
      agencyName: d.companyName || '',
      name: authData.UserName || authData.name || '',
      mobile: authData.Mobile || '',
      cc: authData.CC || '91',
      countryID: d.countryID || 0,
      email: authData.Email || '',
      isWeb: isWeb,
      otp: '',
      connID: 0,
      threadID: 0,
      fcmToken: '',
      source: '',
      signUpSrc: 'ADDAGN',
      timeZone: getTimeZone()
    }];

    const result = await apiService.accessSetData(1, 'signUp', preparedBusinessData);
    checkAPIResponse(result);

    const updatePackage = JSON.parse(result.updatePackage);
    let newBusiness = null;
    try {
      const retData = updatePackage?.Table?.[0]?.RetData;
      if (retData) newBusiness = JSON.parse(retData);
    } catch (e) {
      console.error('Error parsing signUp RetData:', e);
    }

    return { ...updatePackage, newBusiness };
  } catch (error) {
    console.error(`${operation} business API error:`, error);
    throw error;
  }
};